import { ProductsAndDesignSpecificationsResponse, DesignView, BoundingArea } from './types'
import { getDesignSpecificationForProductUrl } from '../../../constants/apiEndpoints'

export const emptyPosition: BoundingArea['position'] = { x: 0, y: 0, width: 0, height: 0 }
export const emptyBoundingArea: BoundingArea = { type: 'Unknown', position: emptyPosition }

export async function getTargetSpecificationForProduct(
  prd: string,
  productVersion: number,
  optionSelections: Record<string, string>,
  culture: string,
): Promise<ProductsAndDesignSpecificationsResponse> {
  const optionsQueryString = Object.keys(optionSelections).reduce(
    (prev, key) => `${prev}${encodeURIComponent(`optionSelections[${key}]`)}=${encodeURIComponent(optionSelections[key])}&`,
    '',
  )
  const response = await fetch(getDesignSpecificationForProductUrl(prd, productVersion, optionsQueryString, culture))
  const json = await response.json()
  return json as ProductsAndDesignSpecificationsResponse
}

export const getBleedArea = (designView: DesignView): BoundingArea => {
  return (
    designView.docAdditionalData.masks.find(mask => mask.pathType === 'BLEED')?.boundingArea ??
    designView.docAdditionalData.masks.find(mask => mask.pathType === 'TRIM')?.boundingArea ??
    designView.docAdditionalData.masks.find(mask => mask.pathType === 'SAFE')?.boundingArea ??
    emptyBoundingArea
  )
}

export const getSafeArea = (designView: DesignView): BoundingArea => {
  return (
    designView.docAdditionalData.masks.find(mask => mask.pathType === 'SAFE')?.boundingArea ??
    designView.docAdditionalData.masks.find(mask => mask.pathType === 'TRIM')?.boundingArea ??
    designView.docAdditionalData.masks.find(mask => mask.pathType === 'BLEED')?.boundingArea ??
    emptyBoundingArea
  )
}
